function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 85.337h512v341.326H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M88.751 221.865a171.427 171.427 0 00-3.417 34.134c0 11.69 1.179 23.105 3.417 34.134L256 300.519l167.249-10.388c2.239-11.029 3.417-22.443 3.417-34.134s-1.179-23.105-3.417-34.134",
  fill: "#0052b4"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M423.249 290.131H88.751c15.813 77.9 84.683 136.534 167.249 136.534s151.436-58.634 167.249-136.534z",
  fill: "#f0f0f0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M330.203 221.865H181.797l30.32-14.262-16.146-29.365 32.923 6.298 4.174-33.26L256 175.738l22.933-24.462 4.172 33.26 32.924-6.298-16.145 29.366z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M255.997 426.661L0 85.335v341.326zm256.003 0V85.335L256.003 426.661z",
  fill: "#a2001d"
});

const SvgAntiguaAndBarbuda = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAntiguaAndBarbuda, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/antigua-and-barbuda.1630266c.svg";
export { ForwardRef as ReactComponent };